"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productFeatureEnabledForServiceLevel = void 0;
const types_1 = require("../types");
const feature_tiers_constants_1 = require("./feature-tiers-constants");
const featureAccessAtoFeatureNameMapping = {
    [types_1.ProductFeatureKeyEnum.TRANSLATIONS]: feature_tiers_constants_1.FeatureNameEnum.AUTO_TRANSLATIONS,
    [types_1.ProductFeatureKeyEnum.MANAGE_ENVIRONMENTS]: feature_tiers_constants_1.FeatureNameEnum.CUSTOM_ENVIRONMENTS_BOOLEAN,
};
function createProductFeatureMap() {
    const productFeatures = {
        [types_1.ProductFeatureKeyEnum.TRANSLATIONS]: [],
        [types_1.ProductFeatureKeyEnum.MANAGE_ENVIRONMENTS]: [],
    };
    for (const apiServiceLevel of Object.values(types_1.ApiServiceLevelEnum)) {
        for (const [productFeatureKey, featureName] of Object.entries(featureAccessAtoFeatureNameMapping)) {
            const typedProductKey = productFeatureKey;
            if (Object.values(types_1.ProductFeatureKeyEnum).includes(typedProductKey)) {
                const isFeatureEnabled = (0, feature_tiers_constants_1.getFeatureForTierAsBoolean)(featureName, apiServiceLevel, {});
                if (isFeatureEnabled) {
                    productFeatures[typedProductKey].push(apiServiceLevel);
                }
            }
        }
    }
    return Object.freeze(productFeatures);
}
exports.productFeatureEnabledForServiceLevel = createProductFeatureMap();
//# sourceMappingURL=productFeatureEnabledForServiceLevel.js.map